export default "__VITE_ASSET__jmpCMYNFYFpcMqmmK4KwRg__"